export const isValidMonth = (mm: number): boolean => mm > 0 && mm < 13;
